import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, useNavigate } from "react-router-dom";
import {  auth,  registerWithEmailAndPassword,  signInWithGoogle,} from "./UsersConfig/Authfirebase";
import "./Users.css";
import Alert from 'react-bootstrap/Alert';
import { validEmail } from "../Tools/ValidateData";
function Register() {
  const [ErrorMsg,setErrorMsg]=useState("");
const [ShowError,setShowError]=useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [user, loading, error] = useAuthState(auth);

  const navigate = useNavigate();
/*Registrar usuario con cuenta diferente a GMAIL*/
  const register = () => {
    if (!validEmail.test(email)) {showError("Proporcionar un correo valido"); return;}
    if (!password) {showError("Proporcionar contraseña"); return;}
    if (password!==password2) {showError("Las contraseñas no coinciden"); return;}
    registerWithEmailAndPassword(email, password);
  };

  useEffect(() => {
    if (loading) return;
    if (user) navigate("/NoAutorizado");
  }, [user, loading]);
  const showError=(msg)=>{
    setErrorMsg(msg);
    setShowError(true);
  }
  return (

      <div className="containerUser">
      <img src={process.env.PUBLIC_URL+"/Logo.png"}  alt="Empresa"/>
        <h3>Crear cuenta</h3>
        <Alert variant="danger" onClose={() => setShowError(false)} dismissible show={ShowError} >
        <Alert.Heading>Revisar!</Alert.Heading>
        <p>
    {ErrorMsg}
        </p>
      </Alert>
        <input type="text" className="bsInput"  value={email} onChange={(e) => setEmail(e.target.value)}  placeholder="📧 E-mail Address" />
        <input type="password" className="bsInput" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"/>
        <input type="password" className="bsInput" value={password2} onChange={(e) =>setPassword2(e.target.value)} placeholder="Repetir Password"/>
        <button className="bsButton" onClick={register}>  Registrar </button>
      
        <div>
          ¿Ya tienes cuenta? <Link to="/Login">Login</Link>
        </div>
        <span>O</span>
        <h5>Crear cuenta con Gmail</h5>
        <button className="bsButton2" onClick={signInWithGoogle}  >📧 Registrate con Gmail </button>*
      </div>
   
  );
}

export default Register;